// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-runtime/core-js/json/stringify'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
import VModal from 'vue-js-modal'
import Multiselect from 'vue-multiselect'
import VTooltip from 'v-tooltip'
import Datepicker from 'vuejs-datepicker'
import VueTimepicker from 'vue2-timepicker'
import VueUploadComponent from 'vue-upload-component'
import FileUpload from 'v-file-upload'
import VueCharts from 'vue-chartjs'

import moment from 'moment'

import VueLocalStorage from 'vue-ls'

// import persistentState from 'vue-persistent-state'

Vue.prototype.$moment = moment

Vue.prototype.$moment.locale('cs')

Vue.use(VModal)

Vue.component('multiselect', Multiselect)

Vue.use(BootstrapVue)

Vue.use(VTooltip)

Vue.use(FileUpload)

Vue.component('chart', VueCharts)

Vue.component('datepicker', Datepicker)

Vue.component('timepicker', VueTimepicker)

Vue.component('fileupload', VueUploadComponent)

Vue.filter('genderToCS', function (gender) {
  if (gender === 'male') {
    return 'muž'
  } else if (gender === 'female') {
    return 'žena'
  } else {
    return 'neznámé'
  }
})

Vue.filter('neverEmpty', function (text) {
  if (text === '' || text === null) {
    return '-'
  } else {
    return text
  }
})

Vue.filter('daysToCS', function (text) {
  if (text > 5) {
    return text + ' dnů'
  } else if (text > 1) {
    return text + ' dny'
  } else if (text > 0) {
    return text + ' den'
  }
})

Vue.filter('boolToCS', function (text) {
  if (text === true) {
    return 'ano'
  } else {
    return 'ne'
  }
})

Vue.filter('boolAndNullToCS', function (text, nullText) {
  if (text === null) {
    return nullText
  } else if (text === true) {
    return 'ano'
  } else {
    return 'ne'
  }
})

Vue.filter('insuranceTypeIntToName', function (num) {
  switch (parseInt(num)) {
    case 1:
      return 'Veřejné zdravotní pojištění'
    case 2:
      return 'Smluvní připojištění'
    case 3:
      return 'Cestovní připojištění'
    case 4:
      return 'Mezistátní pojištění (včetně EU)'
    default:
      return num
  }
})

Vue.filter('stateToCS', function (text) {
  switch (text) {
    case 'scheduled':
      return 'naplánováno'
    case 'arrived':
      return 'v čekárně'
    case 'elaborated':
      return 'rozpracovaný'
    case 'failed':
      return 'nepřišel (bez omluvy)'
    case 'excused':
      return 'nepřišel (omluvil se)'
    case 'completed':
      return 'dokončená'
    case 'canceled':
      return 'zrušená návštěva'
    default:
      return ''
  }
})

Vue.filter('taskStateToCS', function (text) {
  switch (text) {
    case 'accepted':
      return 'přijatý (nepřiřazený)'
    case 'assigned':
      return 'přijatý'
    case 'wait_for_doctor':
      return 'předáno na doktora'
    case 'elaborated':
      return 'rozpracovaný'
    case 'completed':
      return 'splněný'
    case 'canceled':
      return 'zrušená návštěva'
    default:
      return ''
  }
})

Vue.filter('toCSBasedOnNumber', function (text, num) {
  let dictionary = {
    day: [
      'den',
      'dny',
      'dnů'
    ],
    week: [
      'týden',
      'týdny',
      'týdnů'
    ],
    month: [
      'měsíc',
      'měsíce',
      'měsíců'
    ],
    quarter: [
      'čtvrtletí',
      'čtvrtletí',
      'čtvrtletí'
    ],
    semester: [
      'pololetí',
      'pololetí',
      'pololetí'
    ],
    year: [
      'rok',
      'roky',
      'let'
    ]
  }
  if (num === 1) {
    return dictionary[text][0]
  } else if (num < 5) {
    return dictionary[text][1]
  } else {
    return dictionary[text][2]
  }
})

Vue.filter('minutesToCsTime', function (num) {
  let hours = Math.floor(num / 60)
  let minutes = num % 60
  let returnString = ''
  if (hours === 24) {
    return 'celý den'
  } else if (hours > 4) {
    returnString = hours + ' hodin'
  } else if (hours > 1) {
    returnString = hours + ' hodiny'
  } else if (hours === 1) {
    returnString = hours + ' hodina'
  }
  if (minutes > 0) {
    if (hours > 0) {
      returnString = returnString + ' '
    }
    returnString = returnString + minutes + ' minut'
  }
  return returnString
})

Vue.filter('window15toTime', function (num) {
  let hoursFrom = Math.floor((num - 1) / 4)
  let hoursTo = Math.floor(num / 4)
  let minutesFrom = ((num - 1) % 4) * 15
  let minutesTo = ((num) % 4) * 15
  return hoursFrom + ':' + minutesFrom.toString().padStart(2, 0) + ' - ' + hoursTo + ':' + minutesTo.toString().padStart(2, 0)
})

Vue.filter('window10toTime', function (num) {
  let hoursFrom = Math.floor((num - 1) / 6)
  let hoursTo = Math.floor(num / 6)
  let minutesFrom = ((num - 1) % 6) * 10
  let minutesTo = ((num) % 6) * 10
  return hoursFrom + ':' + minutesFrom.toString().padStart(2, 0) + ' - ' + hoursTo + ':' + minutesTo.toString().padStart(2, 0)
})

Vue.filter('windowToMinute', function (num) {
  return num * 10 // TODO - multyply by setting window size
})

let options = {
  namespace: 'clnco__'
}

Vue.use(VueLocalStorage, options)

/* let initialState = {
  auth_locked: ''
} */

Vue.mixin({
  created: function () {
    let myOption = this.$options.myOption
    if (myOption) {
      console.log(myOption)
    }
  }
})

/*
Vue.use(persistentState, initialState) */

/* Vue.axios.interceptors.response.use((response) => { // intercept the global error
  return response
}, function (error) {
  if (error.response.status === 401) {
    console.log('Neplatný token odhlašuji')
    localStorage.removeItem('token')
    localStorage.removeItem('authenticated')
    localStorage.removeItem('role')
    localStorage.removeItem('fullname')
    localStorage.removeItem('userid')
    this.$router.go('/login')
  }
  return Promise.reject(error)
}) */

/* Vue.axios.interceptors.response.use(response => {
  // Everything fine, just pass it for further processing.

  return response
}, error => {
  // If it is an HTTP error
  if (error.response) {
    console.log('session expired')
    if (error.response.status === 401 && error.response.data.error.session_expired === true) {
      console.log('odchytavam 401')
      // Set the new token as default HTTP header.
      // Vue.axios.defaults.headers.common['X-CSRF-TOKEN'] = error.response.data.newToken;

      // If the user was signed in, we need to prompt for password.
      /* if(app.signedIn) {
        return new Promise((resolve, reject) => {

          // Request the password from user.
          app.requestPassword()
            .then(() => {
              // If the user succeeds with authentication
              // Repeat the same request with the new token and return the response to the original requesting function.

              let request = error.response.config
              request.headers['X-CSRF-TOKEN'] = error.response.data.newToken

              axios.request(request).then(response => {
                resolve(response)
              }, error => {
                reject(error)
              })
            })
        })
      } */
/* } else {
      // Handle other errors
    }
  }
  return Promise.reject(error)
}) */

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js